import { IConstanciaResumo } from "../interfaces/IConstancia";
import api from "./Api";

class ConstanciaService {
    async obterResumo(esteiraId: number, codigoContabil: string): Promise<IConstanciaResumo> {
        const { data } = await api.get<IConstanciaResumo>(`Constancia/resumo/${esteiraId}/${codigoContabil}`, {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
        });

        return data;
    }
}

export default new ConstanciaService();
